module.exports = __webpack_public_path__ + "static/dragon-brass-ancient-mtg_cls-c47cf47409214cf9ac94bc6ba9f428dc.jpg";